import { createSlice } from '@reduxjs/toolkit';
import { PartnersEnum } from 'constants/partners';
import { createThunk } from 'helpers/api';

import { revokePartnerToken } from './partner-token-version-slice';

const initialState = {
  config: {},
  tas: {},
  job_adder: {},
  jazzhr: {},
  teamtailor: {},
  bullhorn: {},
  onboarded: {},
  lever: {},
  account_api: {},
  bambooHR: {},
  pageup: {},
  livehire: {},
  smartrecruiters: {},
  cornerstone: {},
  greenhouse: {},
  jobylon: {},

  fetched: false,
};

export const getPartnersConfig = createThunk('getPartnersConfig', 'partners_config', 'get');

export const updatePartnersConfig = createThunk('updatePartnersConfig', 'partners_config', 'put');

export const connectLever = createThunk('connectLever', 'partners_config/lever', 'post');

export const disconnectLever = createThunk('disconnectLever', 'partners_config/lever', 'delete');

export const connectJobAdder = createThunk('connectJobAdder', 'partners_config/jobadder', 'post');

export const disconnectJobAdder = createThunk(
  'disconnectJobAdder',
  'partners_config/jobadder',
  'delete',
);

export const connectLivehire = createThunk('connectLivehire', 'partners_config/livehire', 'post');

export const disconnectLivehire = createThunk(
  'disconnectLivehire',
  'partners_config/livehire',
  'delete',
);

export const connectSmartRecruiters = createThunk(
  'connectSmartRecruiters',
  'partners_config/smartrecruiters',
  'post',
);

export const connectCornerstone = createThunk(
  'connectCornerstone',
  'partners_config/cornerstone',
  'post',
);

export const disconnectCornerstone = createThunk(
  'disconnectCornerstone',
  'partners_config/cornerstone',
  'delete',
);

export const regenerateCornerstonePassword = createThunk(
  'regenerateCornerstonePassword',
  'partners_config/cornerstone/regenerate_password',
  'post',
);

export const connectGreenhouse = createThunk(
  'connectGreenhouse',
  'partners_config/greenhouse',
  'post',
);

export const disconnectGreenhouse = createThunk(
  'disconnectGreenhouse',
  'partners_config/greenhouse',
  'delete',
);

export const connectJobylon = createThunk('connectJobylon', 'partners_config/jobylon', 'post');

export const disconnectJobylon = createThunk(
  'disconnectJobylon',
  'partners_config/jobylon',
  'delete',
);

const partnerConfigSlice = createSlice({
  name: 'partners_config',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPartnersConfig.fulfilled, (_, { payload }) => {
        return { ...payload, fetched: true };
      })
      .addCase(updatePartnersConfig.fulfilled, (state, { payload }) => {
        return { ...state, ...payload };
      })
      .addCase(revokePartnerToken.fulfilled, (state, { payload }) => {
        state[PartnersEnum[payload.partner]].api_key = payload.token;
      })
      .addCase(connectLever.fulfilled, state => {
        state.lever.enabled = true;
      })
      .addCase(disconnectLever.fulfilled, state => {
        state.lever.enabled = false;
      })
      .addCase(connectLivehire.fulfilled, (_, { payload }) => {
        return {
          ...payload,
          fetched: true,
        };
      })
      .addCase(disconnectLivehire.fulfilled, (_, { payload }) => {
        return {
          ...payload,
          fetched: true,
        };
      })
      .addCase(connectJobAdder.fulfilled, state => {
        state.job_adder.enabled = true;
      })
      .addCase(disconnectJobAdder.fulfilled, state => {
        state.job_adder.enabled = false;
      })
      .addCase(connectSmartRecruiters.fulfilled, state => {
        state.smartrecruiters.enabled = true;
      })
      .addCase(connectCornerstone.fulfilled, (state, { payload }) => {
        state.cornerstone = {
          ...state.cornerstone,
          enabled: true,
          cornerstone_basic_auth_username: payload.username,
          base_service_url: payload.base_service_url,
        };
      })
      .addCase(disconnectCornerstone.fulfilled, state => {
        state.cornerstone = {
          ...state.cornerstone,
          enabled: false,
          cornerstone_basic_auth_username: null,
          cornerstone_edge_api_key: null,
        };
      })
      .addCase(connectGreenhouse.fulfilled, (_, { payload }) => {
        return {
          ...payload,
          fetched: true,
        };
      })
      .addCase(disconnectGreenhouse.fulfilled, state => {
        state.greenhouse.enabled = false;
      })
      .addCase(connectJobylon.fulfilled, (state, { payload }) => {
        state.jobylon = {
          ...state.jobylon,
          ...payload,
          enabled: true,
        };
      })
      .addCase(disconnectJobylon.fulfilled, state => {
        state.jobylon = {
          ...state.jobylon,
          enabled: false,
          jobylon_company_id: null,
        };
      });
  },
});

export const selectPartnersConfig = state => state.partnersConfig;

export default partnerConfigSlice.reducer;
